module.exports = __webpack_public_path__ + "img/screen-toi.ec7dc678.png";